import React, { useMemo } from 'react';

import EntityDropDownFilterContainerComponent from 'components/entityViewer/entitiesDropDownFilter/EntityDropDownFilterContainer';
import { mapCompanySourcesToOptions, useCompanySourcesQuery } from 'shared/hooks/inventory/useCompanySourcesQuery';

import { OOS_LOG_FILTER_QUERY_KEYS, OosLogFilterConfigArray } from './OosLogFilterConfig';

/** Stable default so `initialValues` is not a fresh `{}` every render (avoids spurious sync effects). */
const EMPTY_INITIAL_FILTER_VALUES = Object.freeze({});

/**
 * @param {Object} props
 * @param {Object} [props.initialValues={}]
 * @param {(filterValues: Object) => void} [props.onChange]
 */
export function OosLogFilters({ initialValues = EMPTY_INITIAL_FILTER_VALUES, onChange }) {
    const { data: companySources = [], isError, isLoading } = useCompanySourcesQuery();
    const companySourceOptions = useMemo(() => mapCompanySourcesToOptions(companySources), [companySources]);
    const effectiveFilterConfigs = useMemo(
        () =>
            OosLogFilterConfigArray.map((config) => {
                if (config.remoteOptions?.queryId !== OOS_LOG_FILTER_QUERY_KEYS.COMPANY_SOURCES) {
                    return config;
                }

                return {
                    ...config,
                    options: companySourceOptions,
                    menuProps: {
                        ...config.menuProps,
                        hasError: isError,
                        isLoading,
                    },
                };
            }),
        [companySourceOptions, isError, isLoading],
    );

    const handleFilterChange = (filterValues) => {
        onChange?.(filterValues);
    };

    return (
        <EntityDropDownFilterContainerComponent
            title="Out of Stock Log Filters"
            filterConfigs={effectiveFilterConfigs}
            initialValues={initialValues}
            onChange={handleFilterChange}
            autoApply
        />
    );
}
